









import { Component } from 'vue-property-decorator';
import EntryCategoryTable from '@entries/components/tables/entry-category-table/entry-category-table.vue';
import Vue from 'vue';

@Component({
  name: 'bpc-entry-categories',
  components: {
    'bpc-entry-category-table': EntryCategoryTable,
  },
})
export default class EntryCategory extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
